import { defineModule } from '@portal/kernel';

/** Attendance from the office time clock (docs/design/P6B_ATTENDANCE.md). */
export const manifest = defineModule({
  key: 'attendance',
  version: '0.1.0',
  kind: 'business',
  coreVersion: '^0.1.0',
  name: { vi: 'Chấm công', en: 'Attendance' },
  description: {
    vi: 'Lượt chấm từ máy chấm công trong văn phòng, công từng ngày và bảng công tháng.',
    en: 'Punches from the office time clock, daily attendance and the monthly timesheet.',
  },
  dependsOn: ['core-system', 'core-audit', 'core-identity', 'core-organization', 'core-access'],
  database: { schema: 'attendance' },
  permissions: [
    {
      key: 'attendance.timesheet.view-all',
      name: { vi: 'Xem chấm công cả công ty', en: 'View everyone’s attendance' },
    },
    {
      key: 'attendance.setup.manage',
      name: {
        vi: 'Quản lý máy chấm công, ghép mã chấm công, giờ làm',
        en: 'Manage time clocks, enrolment codes and working hours',
      },
    },
  ],
  navigation: [
    {
      id: 'attendance',
      label: { vi: 'Chấm công', en: 'Attendance' },
      icon: 'clock',
      order: 52,
      children: [
        {
          id: 'attendance.mine',
          label: { vi: 'Công của tôi', en: 'My attendance' },
          icon: 'calendar-check',
          path: '/attendance',
          order: 1,
        },
        {
          id: 'attendance.board',
          label: { vi: 'Bảng công', en: 'Timesheet' },
          icon: 'table',
          path: '/attendance/board',
          permission: 'attendance.timesheet.view-all',
          order: 2,
        },
        {
          id: 'attendance.devices',
          label: { vi: 'Máy chấm công', en: 'Time clocks' },
          icon: 'fingerprint',
          path: '/attendance/devices',
          permission: 'attendance.setup.manage',
          order: 3,
        },
      ],
    },
  ],
  roleTemplates: [
    {
      key: 'viewer',
      name: { vi: 'Xem chấm công toàn công ty', en: 'Company-wide attendance viewer' },
      description: { vi: 'Nhân sự hành chính, quản lý, CEO: xem bảng công của mọi người.' },
      grants: [{ permission: 'attendance.timesheet.view-all' }],
    },
    {
      key: 'admin',
      name: { vi: 'Quản lý chấm công', en: 'Attendance administrator' },
      description: { vi: 'Xem bảng công, quản lý máy chấm công, ghép mã và giờ làm.' },
      grants: [
        { permission: 'attendance.timesheet.view-all' },
        { permission: 'attendance.setup.manage' },
      ],
    },
  ],
});
